import { appTheme } from '@deltek/specification-client/core/Themes/AppTheme'
import { createTheme } from '@material-ui/core/styles'
import { harmonyTheme } from './harmonyTheme'

const KpcAppTheme = createTheme({
    ...appTheme,
    overrides: {
        ...appTheme.overrides,
        MuiInputLabel: {
            root: {
                color: 'rgba(0,0,0,0.54)',
            },
        },
    },
    palette: {
        primary: {
            main: '#2F4858',
            light: '#5F788A',
            dark: '#185e8e',
            contrastText: '#fff',
        },
        secondary: {
            main: '#A78966',
            light: '#B7A99A',
            dark: '',
            contrastText: '#fff',
        },
        grey: {
            700: '#5E5F61',
            800: '#464646',
            900: '#343434',
        },
        text: {
            primary: '#343434', // Use this as our primary "black" text.
            secondary: '#a78966', // Same as secondary main. Use this for highlight texts.
            disabled: '#A7ACA8',
        },
        success: {
            main: '#33B55b',
            light: '#9BDE7E',
            contrastText: '#686B8C',
        },
        common: {
            black: '#000',
            white: '#fff',
        },
        tonalOffset: 0.2,
        contrastThreshold: 3,
    },
    breakpoints: {
        values: {
            ...appTheme.breakpoints.values,
            sm: 757,
        },
    },
    harmony: harmonyTheme,
})

export default KpcAppTheme
